import React from 'react';
import EditDescriptionDialog, {EditDescriptionDialogProps} from './EditDescriptionDialog';
import trackAnalytics from '../../utils/gaia/trackAnalytics';
import fetchUser from '../../utils/gaia/fetchUser';

interface FieldEditButtonProps extends EditDescriptionDialogProps {
    editedText: string;
    anchorTitle: string;
    editTitle: string;
}

interface FieldEditButtonState {
    dialogOpen: boolean;
    user: User | undefined;
}

export default class FieldEditButton
    extends React.Component<FieldEditButtonProps, FieldEditButtonState> {

    constructor(props: FieldEditButtonProps) {
        super(props);
        this.state = {
            dialogOpen: false,
            user: undefined,
        };
    }

    async componentDidMount() {
        this.setState({user: await fetchUser()});
    }

    render() {
        return (
            <span style={{verticalAlign: 'top'}}>
                <a
                    href="#"
                    title={this.props.anchorTitle}
                    onClick={e => { e.preventDefault(); this.toggleState(); }}
                >
                    {this.props.anchorTitle}
                </a>
                <EditDescriptionDialog
                    afterUpdate={editedText => this.props.afterUpdate(editedText)}
                    regionType={this.props.regionType}
                    apiEndpoint={this.props.apiEndpoint}
                    apiType={this.props.apiType}
                    onRequestClose={() => this.toggleState()}
                    open={this.state.dialogOpen}
                    originalText={this.props.originalText}
                    regionId={this.props.regionId}
                    template={this.props.template}
                    text={this.props.editedText}
                    title={this.props.editTitle}
                />
            </span>
        );
    }

    toggleState() {
        const {user} = this.state;
        trackAnalytics('Edit Start', {
            apiType: this.props.apiType,
            category: 'Hike',
            loggedIn: user && user.isAuthenticated,
            regionId: this.props.regionId,
            regionType: this.props.regionType,
        });
        if (user && !user.email.length) {
            window.location.href = '/register/?next=' + window.location.pathname;
            return;
        }
        this.setState({dialogOpen: !this.state.dialogOpen});
    }

}
